// extracted by mini-css-extract-plugin
export default {"container":"hours_container__cRnPx","text":"hours_text__5CHq+","slots":"hours_slots__PC4tw","slot":"hours_slot__93vQR","active":"hours_active__HbB6e"};